import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as AnnouncementDialogReducer from './announcement-dialog-reducer';
import { AnnouncementDialogEffects } from './announcement-dialog-effects';

@NgModule({
  imports: [
    StoreModule.forFeature(
      AnnouncementDialogReducer.announcementDialogKey,
      AnnouncementDialogReducer.AnnouncementDialogReducer
    ),
    EffectsModule.forFeature([AnnouncementDialogEffects]),
  ],
})
export class AnnouncementDialogStoreModule {}
